import React, { useCallback } from 'react';

import * as Yup from 'yup';
import { FormikHelpers } from 'formik';
import { CreateAdminDTO } from '../../models/Admin';
import useSchools from '../../services/swr/useSchools';
import GenericModal from '../../components/GenericModal';
import { Modal, ModalRef } from '../../hooks/useModalRef';
import GenericModalForm from '../../components/GenericModalForm';
import GenericTextInput from '../../components/GenericTextInput';
import GenericSelectList from '../../components/GenericSelectList';
import useSchoolsAdmins from '../../services/swr/useSchoolAdmins';

const AddAdminSchoolModal = React.forwardRef<Modal, object>((_, ref) => {
  const { handleAddSchoolAdmin } = useSchoolsAdmins();
  const { schools } = useSchools();

  const closeModal = useCallback(
    () => (ref as ModalRef).current?.closeModal(),
    [ref],
  );

  const onSubmit = useCallback(
    async (
      values: Record<string, unknown>,
      { setSubmitting, resetForm }: FormikHelpers<Record<string, unknown>>,
    ) => {
      const addSchoolAdminDTO = {
        name: values.name,
        email: values.email,
        schoolId: values.schoolId,
        password: values.password,
      } as CreateAdminDTO;
      await handleAddSchoolAdmin(addSchoolAdminDTO);
      setSubmitting(false);
      resetForm();
      closeModal();
    },
    [handleAddSchoolAdmin, closeModal],
  );

  return (
    <GenericModal className="w-4/5 max-w-[480px]" ref={ref}>
      <div>
        <h1 className="font-sans text-2xl mb-6">Adicionar Administrador</h1>

        <GenericModalForm
          initialValues={{
            // name: '',
            email: '',
            password: '',
            schoolId: '',
          }}
          validationSchema={Yup.object().shape({
            // name: Yup.string().required('Nome obrigatório'),
            schoolId: Yup.string().required('Escola obrigatória'),
            email: Yup.string()
              .required('e-Mail obrigatório')
              .email('Digite um e-Mail válido'),
            password: Yup.string()
              .required('Senha obrigatória')
              .min(6, 'Senha deve conter ao menos 6 caracteres'),
          })}
          onSubmit={onSubmit}
          onCancel={closeModal}
          submitButtonType="create"
        >
          {/* <GenericTextInput
            name="name"
            label="Nome"
            type="text"
            placeholder="Administrador Itus"
          /> */}
          <GenericTextInput
            name="email"
            label="Email"
            type="email"
            placeholder="email@exemplo.com.br"
          />
          <GenericTextInput
            name="password"
            label="Senha"
            type="password"
            placeholder="123456"
          />
          <GenericSelectList
            name="schoolId"
            dataArray={schools}
            optionLabel="name"
            label="Pertence à qual escola"
            placeHolder="Selecione a Escola"
          />
        </GenericModalForm>
      </div>
    </GenericModal>
  );
});

AddAdminSchoolModal.displayName = 'AddAdminSchoolModal';

export default AddAdminSchoolModal;
